<template>
    <div v-if="showModal" class="modal">
        <div class="modal-content">
            <span @click="showModal = false" class="close">&times;</span>
            <AppTableSimples v-if="showTable" :table_data="tsimples_data" :visibility="showTable" :show="showTable"
                :table_title="this.tabela" />
        </div>
    </div>
    <div v-if="visibility" class="flex flex-col  h-auto gap-2  text-white rounded-md bg-[#43436d] p-4">
        <div class="w-full flex items-center justify-between p-2">
            <h2 class="text-white">Configurar o filtro da tabela {{ tabela }}</h2>
            <div>
                <input ref="myInput" v-model="filtername" type="text" placeholder="Nome.."
                    class="p-1 outline-none rounded-md text-black" 
                    :class="{'red-border': !filtername}">
            </div>
            <div class="">
                <i class="fa fa-times-circle text-2xl cursor-pointer" @click="close"></i>
            </div>

        </div>

        <div class="flex  gap-1 w-full h-72  p-1 text-white  rounded-md">
            <div class="w-full flex flex-col justify-center  h-full overflow-hidden  rounded-md ">
                <p class="px-1 flex justify-between">Campos<span class="pr-4">Visibilidade</span></p>
                <div class="flex flex-col h-full gap-1 p-1 overflow-y-auto scrollbar-thin scrollbar-tema">
                    <p v-for="name in Object.keys(filteredData[0] || {})" :key="name"
                        class="px-1 rounded-md cursor-pointer text-white hover:bg-[#c67700] flex justify-between"
                        :class="{ 'bg-[#c67700]': selected === name, 'bg-[#626288]': selected !== name }"
                        @click="selectItem(name)" @dblclick="appendItemToSqlString(name)">
                        {{ name }}
                        <span @click.stop="toggleVisibility(name)" class="px-4">
                            <i v-if="visibilityStates[name]" class="fa fa-eye"></i>
                            <i v-else class="fa fa-eye-slash"></i>
                        </span>
                    </p>
                </div>
            </div>
            <div class="w-full flex  flex-col justify-center  h-full overflow-hidden  rounded-md gap-1">
                <p class=" px-1">Valores</p>
                <input type="search" v-model="searchQuery" placeholder="Pesquisar.."
                    class="text-black rounded-md outline-none p-1 w-full m-auto">
                <div class=" flex flex-col h-full gap-1 p-1 overflow-y-auto scrollbar-thin scrollbar-tema">
                    <p v-for="(item, index) in filteredItems" :key="index"
                        class="bg-[#626288] px-1 rounded-md cursor-pointer hover:bg-[#c67700]"
                        @dblclick="appendValueToSqlString(item)">
                        {{ item }}
                    </p>
                </div>
            </div>
        </div>
        <div class="flex flex-col p-2  pb-4 gap-2">
            <p class="text-white">Operadores</p>
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-1">
                <button v-for="(operator, index) in operators" :key="index"
                    class="text-white rounded-md bg-[#626288] hover:bg-[#58587e] px-2 py-1"
                    @click="selectOperator(operator)">
                    {{ operator }}
                </button>
            </div>
            <div class="min-h-36 flex flex-col gap-1">
                <p class="text-white">Expressão de Filtro Específica do Provedor</p>
                <textarea v-model="sqlString" class="w-full h-full outline-none rounded-md p-1 text-black"></textarea>
            </div>
            <div class="w-2/3 m-auto ">
                <div class=" grid grid-flow-col  gap-1 ">
                    <button v-for="(text, index) in buttonText" :key="index"
                        class="text-white rounded-md bg-[#626288] hover:bg-[#58587e] px-2 py-1"
                        @click="handleButtonClick(text)">
                        {{ text }}
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import axios from 'axios';
import AppTableSimples from '@/components/tables/tableSimples.vue'
import AppButton from '@/components/button.vue'
export default {
    name: 'AppFilterForm',
    components: {
        AppTableSimples,
        AppButton
    },
    data() {
        return {
            baseURl: process.env.VUE_APP_URL_BASE,
            dataResponse: [],
            filteredData: [],
            selected: null,
            selectedValue: null,
            column: null,
            campo: [],
            searchQuery: '',
            operators: ['=', '!=', '<', '>', '<=', '>=', 'LIKE', 'ILIKE', '%', 'IN', 'NOT IN', 'AND', 'OR', 'NOT', 'IS NULL', 'NOT NULL'],
            buttonText: ['Testar', 'Limpar', 'Guardar', 'Desfazer'],
            sqlString: '',
            sqlStringHistory: [],
            isSqlStringFinalized: false,
            visibilityStates: {},
            user: null,
            isSqlStringSent: false,
            tabela: this.tabela,
            tsimples_data: [],
            showTable: false,
            showModal: false,
            showForm: false,
            filtername: '',

        }
    },
    props: {
        tabela: {
            type: String,
            required: true
        },
        visibility: {
            type: Boolean,
            required: true
        },
    },
    computed: {
        filteredItems() {
            if (!this.searchQuery) {
                return this.filteredData.map(item => item[this.column]);
            }
            const query = this.searchQuery.toLowerCase();
            return this.filteredData.map(item => item[this.column]).filter(item => String(item).toLowerCase().includes(query));
        },
    },
    mounted() {
        const user = localStorage.getItem('user');

        if (user) {
            this.user = JSON.parse(user);
        }
    },
    methods: {
        async fetchData() {
            try {
                const response = await axios.get(`${this.baseURl}/api/v1/${this.tabela}/`);
                if (response.status >= 200 && response.status < 300) {
                    if (this.tabela === 'perfil') {
                        this.dataResponse = response.data.data
                            .filter(item => item.utilizador_id === -1)
                            .sort((a, b) => a.id - b.id);
                    } else {
                        this.dataResponse = response.data.data.sort((a, b) => a.id - b.id);
                    }
                    this.filterData();
                } else {
                    console.log('Request failed with status code', response.status);
                }
            } catch (error) {
                console.error('An error occurred while making the request', error);
            }
        },
        async sendSqlString(url, action) {
            if (!this.isSqlStringFinalized) {
                this.finalizeSqlString();
            }
            try {
                const postData = {
                    nome: this.filtername,
                    campo: this.campo,
                    tabela: this.tabela,
                    utilizador_id: this.user.id,
                    stringSql: this.sqlString,
                };
                console.log('DataFiltro', postData);
                const response = await axios.post(url, postData);

                if (response.status >= 200 && response.status < 300) {
                    if (action === 'testar') {
                        this.tsimples_data = response.data.data
                        this.showModal = true;
                        this.showTable = true;
                        console.log('SQL query sent successfully', response.data.data);
                    }
                    else if (action === 'registrar') {
                        console.log('SQL query sent successfully', response);
                        this.handleLimpar();
                        this.$emit('close');
                    }


                } else {
                    console.log('Request failed with status code', response.status);
                }
            } catch (error) {
                console.error('An error occurred while making the request   ', error);
            }
        },
        toggleVisibility(name) {
            if (this.visibilityStates[name] === undefined) {
                this.visibilityStates[name] = true;
                this.campo.push(name);
            } else {
                this.visibilityStates[name] = !this.visibilityStates[name];
                if (this.visibilityStates[name]) {
                    this.campo.push(name);
                } else {
                    const index = this.campo.indexOf(name);
                    if (index !== -1) {
                        this.campo.splice(index, 1);
                    }
                }
            }
        },
        close() {
            this.$emit('close');
        },
        openForm() {
            this.showForm = true;
        },
        appendItemToSqlString(name) {
            this.sqlString += ` ${name} `;
            this.sqlStringHistory.push(this.sqlString);
        },
        appendValueToSqlString(item) {
            this.sqlString += ` '${item}' `;
            this.sqlStringHistory.push(this.sqlString);
        },
        finalizeSqlString() {
            let campos = this.campo;
            if (!campos.includes('id')) {
                campos.push('id');
            }
            this.sqlString = `select ${campos.join(', ')} from safety.${this.tabela} where ${this.sqlString}`;
            this.isSqlStringFinalized = true;
        },
        filterData() {
            this.filteredData = this.dataResponse.map(item => {
                let filteredItem = {};
                for (let attribute in item) {
                    if (item.hasOwnProperty(attribute) && typeof item[attribute] !== 'object') {
                        filteredItem[attribute] = item[attribute];
                    }
                }
                return filteredItem;
            });
        },
        selectItem(name) {
            // this.selected = name;
            this.selectedItemData = this.filteredData.map(item => item[name]);
            this.filterData(name);
            this.column = name;
        },
        selectOperator(operator) {
            this.sqlString += ` ${operator}`;
            this.sqlStringHistory.push(this.sqlString);
        },
        constructSqlString() {
            if (this.column && this.selectedValue && this.operator) {
                if (this.sqlString === '') {
                    this.sqlString = `${this.column} ${this.operator} '${this.selectedValue}'`;
                } else {
                    this.sqlString = `${this.sqlString} AND ${this.column} ${this.operator} '${this.selectedValue}'`;
                }
                
            }
        },
        handleOk() {
            // Handle functionality for OK button

        },
        handleTestar() {
            this.sendSqlString(`${this.baseURl}/api/v1/filtro/testar/`, 'testar');
        },
        handleLimpar() {
            this.column = null;
            this.operator = null;
            this.selected = null;
            this.filtername = '';
            this.sqlString = '';
            this.isSqlStringFinalized = false;
        },
        handleGuardar() {
            this.sendSqlString(`${this.baseURl}/api/v1/filtro/registrar/`, 'registrar');
        },
        handleDesfazer() {
            if (this.sqlStringHistory.length > 1) {
                this.sqlStringHistory.pop(); // Remove the last SQL string from the history
                this.sqlString = this.sqlStringHistory[this.sqlStringHistory.length - 1]; // Set the SQL string to the new last item in the history
            } else {
                this.sqlString = ''; // If there's only one item in the history, clear the SQL string
            }

        },
        handleButtonClick(text) {
            switch (text) {
                case 'Testar':
                    // Handle functionality for Testar button
                    this.handleTestar();
                    break;
                case 'Limpar':
                    // Handle functionality for Limpar button
                    this.handleLimpar();
                    break;
                case 'Guardar':
                    this.handleGuardar();
                    // Handle functionality for Guardar button
                    break;
                case 'Desfazer':
                    this.handleDesfazer()
                    break;
                default:
                    // Optional: Handle functionality for unknown button
                    break;
            }
        },
    },
    created() {
        this.fetchData();
    },
    watch: {
        visibility(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.$refs.myInput.focus();
                });
            }
        },
        tabela(newVal) {
            this.fetchData();
        }
    },



}

</script>
<style scoped>
.modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    border-radius: 8px;
    background-color: #2e2e48;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}
.red-border {
    background-color: rgba(176, 88, 88, 0.664)
}

.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}
</style>
